import { enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { QuillModule } from 'ngx-quill';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { GlobalErrorHandler } from './app/GlobalErrorHandler';
import { appRoutes } from './app/app.routes';
import { MsalConfigModule } from './app/core/auth/msal-config.module';
import { providePortalHttpClient } from './app/core/auth/portal-http.providers';
import { AuthService } from './app/shared/services/auth.service';
import { AccountSwitchService } from './app/shared/services/account-switch/account-switch.service';
import { SharedModule } from './app/shared/shared.module';
import { ErrorInterceptorService } from './app/shared/services/interceptors/error-interceptor.service';
import './app/core/i18n/register-locales';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes),
    importProvidersFrom(SharedModule, FormsModule, MsalConfigModule.forRoot(), QuillModule.forRoot()),
    providePortalHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
    AuthService,
    MessageService,
    DialogService,
    AccountSwitchService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
}).catch((err) => console.error(err));
